
  import { css } from 'lit';
  export const styles = css`:host{--item-icon: 1.125rem}:host ::slotted(igc-icon){--size: var(--item-icon)}`;
  